<app-label [label]="name">
  <div class="value__wrapper">
    <app-parse-multimedia-links class="text_size_{{ size }}" [value]="value"></app-parse-multimedia-links>
  </div>
</app-label>
